export default __webpack_public_path__ + "static/media/calendar_Icon.b17468b1.svg";